import BaseView from '../../base-view';
import ToggleMixin from '../../mixins/toggle';

export default BaseView.extend({
	mixins: [ToggleMixin]
});
